import { objToUrlParams } from '@/utils'
import request from '@/utils/request'

// 获取入金订单列表
export const getOrderList = (params: any) => request({
  url: '/manage/deposit-order',
  method: 'get',
  params
})

// 入金订单详情
export const getOrderInfo = (params: any) => request({
  url: '/manage/deposit-order/' + params.ordernumber,
  method: 'get',
  params
})

// 修改未支付入金订单
export const setUnpaidOrder = (data: any) => request({
  url: '/manage/unpaid-deposit-order/' + data.ordernumber + '/change/status',
  method: 'put',
  data: {
    ...data,
    authCode: 'change_unpaid_deposit_order_status'
  }
})

// 修改已支付入金订单
export const setPaidOrder = (data: any) => request({
  url: '/manage/paid-deposit-order/' + data.ordernumber + '/change/status',
  method: 'put',
  data: {
    ...data,
    authCode: 'change_paid_deposit_order_status'
  }
})

// 入金订单导出
export const orderExport = (data: any) => request({
  url: '/manage/deposit-order-export' + objToUrlParams(data),
  method: 'post'
})

// 订单归集日志列表
export const orderCollectionLog = (params: any) => request({
  url: '/manage/order/' + params + '/collection-log',
  method: 'get'
})

// 入金订单统计
export const depositOrderStatistical = (params: any) => request({
  url: '/manage/deposit-order-statistics',
  method: 'get',
  params
})

// 发起付款
export const batchOrderCap = (data: any) =>
  request({
    url: `/manage/batch-order-usd-cap`,
    method: 'post',
    data
  })

// 退款
export const depositRefund = (data: any) =>
  request({
    url: `/manage/deposit-orders/refund`,
    method: 'post',
    data
  })

// 获取子产品
export const getOrderSubProduct = (params: any) => {
  return request({
    url: '/manage/sub-product-extra-field',
    method: 'get',
    params
  })
}